/* CTD tier progress — smooth fill animation across cart-drawer re-renders */
(function () {
  if (window.__ctdTierProgressInit) return;
  window.__ctdTierProgressInit = true;

  function animate(el) {
    var fill = el.querySelector('.ctd-tier-progress__fill');
    if (!fill) return;
    var target = parseFloat(el.dataset.percent);
    if (isNaN(target)) return;
    var last = window.__ctdTierProgressLast;
    if (typeof last === 'number' && !isNaN(last) && last !== target) {
      var t = fill.style.transition;
      fill.style.transition = 'none';
      fill.style.width = last + '%';
      void fill.offsetWidth; // force reflow
      fill.style.transition = t || '';
      requestAnimationFrame(function () {
        fill.style.width = target + '%';
      });
    } else {
      fill.style.width = target + '%';
    }
    window.__ctdTierProgressLast = target;
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.classList && node.classList.contains('ctd-tier-progress')) {
      animate(node);
      return;
    }
    if (node.querySelectorAll) {
      node.querySelectorAll('.ctd-tier-progress').forEach(animate);
    }
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) scan(added[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  function init() { scan(document.body); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
